export {
  languageMapping,
  languageIdMapping,
  defaultCode,
  COMPILER_LANGUAGES,
  PROBLEM_LANGUAGES,
  isCompilerLanguage,
  getCompilerLanguage,
  getMonacoLanguage,
} from './compilerLanguages';

export const PAYMENT_LIVE_KEY = 'rzp_live_HNVta8PtH0jaDD';
export const GOOGLE_SIGN_IN_CLIENT_ID = '571125736587-gtloib4pgjblhppieh0eom3n4194grn7.apps.googleusercontent.com';
export const GITHUB_CLIENT_ID = 'Ov23liSJPRPH2Zwoifap';

export const DEV_INTERVIEW_PRICE = 249;
export const DSA_INTERVIEW_PRICE = 349;
/** Schedule a mock interview session (INR) — standard price. */
export const MOCK_INTERVIEW_BOOKING_PRICE = 99;
/** Mock interview price for premium members (INR). */
export const MOCK_INTERVIEW_PREMIUM_PRICE = 1;

export const getMockInterviewPrice = (isPremiumUser = false) =>
  isPremiumUser ? MOCK_INTERVIEW_PREMIUM_PRICE : MOCK_INTERVIEW_BOOKING_PRICE;
/** Longer 1–2 hour guidance / deep-dive session (INR). */
export const GUIDANCE_SESSION_PRICE = 1199;
/** Full 1:1 mentorship — monthly (INR). */
export const MENTORSHIP_MONTHLY_PRICE = 11999;
/** Full 1:1 mentorship — 6–7 month plan (INR). */
export const MENTORSHIP_SIX_MONTH_PRICE = 59999;
export const PLATFORM_ACCESS_PRICE = 999;
export const DSA_COMPLETE_LEVEL_1_PRICE = 3999;
export const DSA_COMPLETE_LEVEL_2_PRICE = 1499;
export const DSA_REVISE_LEVEL_1_PRICE = 1999;

export const interviewTimeSlots = [
    '09:00 AM',
    '10:00 AM',
    '11:00 AM',
    // '12:00 PM',
    // '02:00 PM',
    '03:00 PM',
    '06:00 PM',
    '08:00 PM',
    '09:00 PM',
    '10:00 PM',
    '11:00 PM',
    'Other'
];
